import React, { useEffect } from 'react'
import { useMatch, useNavigate, useSearchParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { Card, Grid, Hidden } from '@material-ui/core'
import { ROUTES } from '../../constants'
import Image01 from 'assets/SMPL_Signin_700x600_01.png'
import Image02 from 'assets/SMPL_Signin_700x600_02.png'
import Image03 from 'assets/SMPL_Signin_700x600_03.png'
import { LoginScreenForms } from 'lib/enums/login.enums'
import { doScrollToTop } from 'lib/helpers/utilities'
import { useAppSelector } from 'store/hooks'
import { setActiveForm } from 'store/Login/login.reducer'
import { selectActiveForm } from 'store/Login/login.selectors'
import LoginFormContainer from 'containers/Login/LoginFormContainer'
import RecoverPasswordFormContainer from 'containers/RecoverPasswordForm/RecoverPasswordFormContainer'
import RegisterForm from 'containers/RegisterForm/RegisterFormContainer'
import Carousel from 'components/Login/Carousel/Carousel'
import './styles.scss'

const LoginScreen = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const activeForm = useAppSelector(selectActiveForm)

  const [params] = useSearchParams()

  const form = params.get('form')
  const email = params.get('email')

  const matchRegister = useMatch(ROUTES.REGISTER)
  const matchLogin = useMatch(ROUTES.LOGIN)

  const isRegister = Boolean(matchRegister)
  const isLogin = Boolean(matchLogin)

  const handleRegisterClicks = () => {
    if (isRegister) {
      navigate(ROUTES.LOGIN)
      dispatch(setActiveForm(LoginScreenForms.LOGIN))
    } else if (isLogin) {
      dispatch(setActiveForm(LoginScreenForms.LOGIN))
    }
  }

  useEffect(() => {
    if (form) {
      dispatch(setActiveForm(form as LoginScreenForms))
      navigate(email ? `${ROUTES.LOGIN}?email=${email}` : ROUTES.LOGIN, {
        replace: true,
      })
    } else if (matchRegister) {
      dispatch(setActiveForm(LoginScreenForms.REGISTER))
    }
    doScrollToTop()

    return () => {
      dispatch(
        setActiveForm(
          isRegister ? LoginScreenForms.REGISTER : LoginScreenForms.LOGIN
        )
      )
    }
  }, [dispatch, navigate, email, form, isRegister, matchRegister])

  return (
    <Card className="screen-login">
      <Grid className="screen-container" container spacing={0}>
        <Grid item xs={12} md={5} lg={4}>
          {activeForm === LoginScreenForms.LOGIN && (
            <LoginFormContainer
              onClickForgetPassword={() =>
                dispatch(setActiveForm(LoginScreenForms.RECOVER))
              }
              onClickRegister={() =>
                dispatch(setActiveForm(LoginScreenForms.REGISTER))
              }
            />
          )}
          {activeForm === LoginScreenForms.REGISTER && (
            <RegisterForm
              email={email || undefined}
              onClickLogin={handleRegisterClicks}
            />
          )}
          {activeForm === LoginScreenForms.RECOVER && (
            <RecoverPasswordFormContainer
              onClickCancel={() =>
                dispatch(setActiveForm(LoginScreenForms.LOGIN))
              }
            />
          )}
        </Grid>
        <Hidden smDown>
          <Grid item xs={12} md={7} lg={8} className="screen-section">
            <Carousel>
              <img src={Image01} alt="Imagen 1" />
              <img src={Image02} alt="Imagen 2" />
              <img src={Image03} alt="Imagen 3" />
            </Carousel>
          </Grid>
        </Hidden>
      </Grid>
    </Card>
  )
}

export default LoginScreen
